import { cn } from '@/lib/cn'

export interface BoneProps {
  className?: string
  /** Brand-tinted bone, for titles, chips and status markers. */
  tint?: boolean
  style?: React.CSSProperties
}

/**
 * A single shimmer placeholder. Size and shape come from `className`; every
 * bone on screen shares one sweep of light (see `.kc-bone` in index.css).
 */
export function Bone({ className, tint, style }: BoneProps): React.ReactElement {
  return <span aria-hidden className={cn('kc-bone block', tint && 'kc-bone--tint', className)} style={style} />
}

Bone.displayName = 'Bone'
